<template>
  <div id="pac-container"
       class="ui form">
    <div class="field">
      <form autocomplete="off">
        <label>Hely megadása</label>
        <input v-if="isCurrentPosition"
               id="pac-input"
               autocomplete="false"
               placeholder="Aktuális pozíció"
               type="text">
        <input v-else
               id="pac-input"
               autocomplete="false"
               placeholder="Cím megadása..."
               type="text">
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      coordinateChanged: false,
    }
  },
  methods: {
    initMap () {
      const input = document.getElementById('pac-input')
      // eslint-disable-next-line
      const autocomplete = new google.maps.places.Autocomplete(input)
      let self = this

      autocomplete.addListener('place_changed', function () {
        let place = autocomplete.getPlace()
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          alert('Válassz egy pontos címet a mezőből')
          return
        }

        let coordinates = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        self.coordinateChanged = true
        self.$emit('on-changed', coordinates)
      })
    },
  },
  computed: {
    isCurrentPosition () {
      return this.$store.state.currentPosition && !this.coordinateChanged
    },
  },
  mounted: function () {
    this.initMap()
  },
}

</script>


<style scoped>
/*
#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}
*/

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  /*font-family: Roboto;*/
  font-size: 13px;
  font-weight: 300;
}

.ui.form .field label {
  color: #d7d9dc;
}

#pac-input {
  /*font-family: Roboto;*/
  font-size: 15px;
  font-weight: 300;
  /*
  margin-left: 12px;
  padding: 0 11px 0 13px;
  width: 400px;
  */
  background: none;
  box-shadow: none;
  border-radius: 0;
  border: 2px solid #b7bfc9;
  text-overflow: ellipsis;
}

#pac-input::placeholder {
  color: rgba(0, 0, 0, .87)
}

#pac-input:focus {
  outline: none
}

/*
#pac-input:focus {
  border-color: #4d90fe;
}
*/

#title {
  color: #fff;
  background-color: #4d90fe;
  font-size: 25px;
  font-weight: 500;
  padding: 6px 12px;
}
</style>
